import Vue from 'vue';

const terminal = process.env.terminal; // 终端
Vue.prototype.messageBoxFn = async (message, type = 'success') => { // 提示框
  return new Promise(resolve => {
    if (terminal === 'xcx' && message) { // 小程序
      wx.showToast({
        title: message,
        icon: 'none',
        duration: 1500
      });
      setTimeout(() => {
        resolve(true);
      }, 1500);
    } else if (terminal === 'h5' && message) { // h5
      let divToast = document.createElement('div');
      divToast.setAttribute('class', 'tool-message-box');
      divToast.innerHTML = message;
      document.body.appendChild(divToast);
      setTimeout(() => {
        document.body.removeChild(divToast);
        resolve(true);
      }, 1500);
    }
  });
};

Vue.mixin({
  data() {
    return {};
  },
  methods: {
    qiniuImgUrlFn(hash) { // 回显七牛云图片
      return `${process.env.qiniuUrl}${hash}`;
    },
    responsiveFn(designWidth = 750) { // 响应式设置  designWidth 设计图宽度
      if (/Android(?:\s+|\/)(\d+\.\d+)?/.test(navigator.userAgent)) {
        var version = parseFloat(RegExp.$1);
        if (version > 2.3) {
          var phoneScale = parseInt(window.screen.width) / designWidth;
          document.write('<meta name="viewport" content="width=' + designWidth + ',minimum-scale=' + phoneScale + ',maximum-scale=' + phoneScale + ', target-densitydpi=device-dpi,user-scalable=no">');
        } else {
          document.write('<meta name="viewport" content="width=' + designWidth + ',target-densitydpi=device-dpi,user-scalable=no">');
        }
      } else {
        document.write('<meta name="viewport" content="width=' + designWidth + ',user-scalable=no,target-densitydpi=device-dpi,minimal-ui,viewport-fit=cover">');
      }
    },
    setStorageFn(name, data) { // 设置本地存储数据
      localStorage.setItem(name, JSON.stringify(data));
    },
    getStorageFn(name) { // 获取本地存储数据
      return JSON.parse(localStorage.getItem(name));
    },
    removeStorageFn(name) { // 删除本地存储数据
      localStorage.removeItem(name);
    },
  }
});



// WEBPACK FOOTER //
// ./src/mixin/index.js